import {
    createAction,
    Action,
    ActionFunction1,
    ActionFunction3,
    ActionFunction2,
} from 'redux-actions';
import {TimelineRowType} from '../TimelineTypes';

export const MARKER_SELECT_TOGGLE = 'MARKER_SELECT_SET';
export const MARKER_SELECT_NEXT_PREVIOUS = 'MARKER_SELECT_NEXT_PREVIOUS';
export const MARKER_SELECTION_RESET = 'MARKER_SELECTION_RESET';

export interface MarkerTogglePayload {
    markerId: string;
    rowId: string;
    type: TimelineRowType;
}

export const toggleSelectedMarkerAction = createAction(MARKER_SELECT_TOGGLE, (markerId: string, rowId: string, type: TimelineRowType): MarkerTogglePayload => {
    return {
        markerId,
        rowId,
        type,
    };
});

export type ToggleSelectedMarker = ActionFunction3<string, string, TimelineRowType, Action<MarkerTogglePayload>>;

export const toggleSelectedRowAction = createAction(MARKER_SELECT_TOGGLE, (rowId: string, type: TimelineRowType): MarkerTogglePayload => {
    return {
        markerId: '',
        rowId,
        type,
    };
});

export type ToggleSelectedRow = ActionFunction2<string, TimelineRowType, Action<MarkerTogglePayload>>;

export interface MarkerSelectNextPreviousPayload {
    markerId: string;
}

export const selectNextPreviousMarkerAction = createAction(MARKER_SELECT_NEXT_PREVIOUS, (markerId: string): MarkerSelectNextPreviousPayload => {
    return {
        markerId,
    };
});

export type SelectNextPreviousMarker = ActionFunction1<string, Action<MarkerSelectNextPreviousPayload>>;
